// Which lookup a code from the hub's scan box belongs to. Box stickers are
// RB- plus eight characters, and people type the bare eight off a scuffed one;
// every carrier tracking number is longer than that.

export type ScanRoute = 'box' | 'request';

export function routeScan(raw: string): ScanRoute | null {
  const code = raw.trim();
  if (!code) return null;
  if (/^R[BI]-/i.test(code) || code.length <= 8) return 'box';
  return 'request';
}
